module.exports = __webpack_public_path__ + "img/calendar.205ed07f.svg";